import React from 'react';

/**
 * ImageScrim — the single standard gradient overlay for text or controls placed
 * on top of a photo. Use this instead of hand-rolling `from-black/NN … to-transparent`
 * gradients (the app had ~6 inconsistent recipes).
 *
 * Place it inside a `relative` image container, *below* the text/controls layer
 * (give those their own `z-raised`). Decorative only — `pointer-events-none` so it
 * never blocks taps, and `aria-hidden` so it isn't announced.
 *
 * @param {'bottom'|'top'} position - which edge the dark end anchors to (default 'bottom')
 * @param {string} className - height/opacity overrides (default height is half the container)
 */
export default function ImageScrim({ position = 'bottom', className = '' }) {
  const pos =
    position === 'top'
      ? 'top-0 bg-gradient-to-b'
      : 'bottom-0 bg-gradient-to-t';
  return (
    <div
      aria-hidden="true"
      className={`pointer-events-none absolute inset-x-0 h-1/2 ${pos} from-black/70 via-black/20 to-transparent ${className}`}
    />
  );
}
